import React from 'react';

import SessionLayout from '../layouts/Session/Session';

import Logout from '../components/Session/Logout';
import {setPageTitle} from '../utils/helpers';

const LogoutPageContainer = () => {
  setPageTitle('Log out | Investec Save');

  return (
    <SessionLayout>
      <Logout />
    </SessionLayout>
  );

};

export default LogoutPageContainer;
